var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuarantee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 29 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8F8",
    d: "M-41-137h375V963H-41z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31 -23)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 350,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#F6F8F7",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.941,
    d: "M44.55 23.845l-10.64 3a.685.685 0 0 0-.495.623c-.171 2.969-.492 18.44 11.13 21.755a.687.687 0 0 0 .368 0c11.623-3.315 11.302-18.786 11.13-21.755a.685.685 0 0 0-.494-.623l-10.64-3a.662.662 0 0 0-.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M44.611 23.845l-10.64 3a.685.685 0 0 0-.494.623c-.172 2.969-.492 18.44 11.13 21.755a.687.687 0 0 0 .368 0c11.623-3.315 11.302-18.786 11.13-21.755a.685.685 0 0 0-.494-.623l-10.64-3a.662.662 0 0 0-.36 0zm.108 1.775l9.468 2.689c.122 3.808-.227 16.052-9.468 18.911-9.24-2.859-9.59-15.103-9.468-18.911l9.468-2.689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M34.613 32l23.832-2.097-1.303 4.925-22.077 2.122c-.191-1.39-.342-2.44-.452-3.15-.11-.71-.11-1.31 0-1.8zM31.9 37.695L54.483 35.6c-.114.908-.264 1.658-.452 2.25-.187.592-.488 1.342-.903 2.25l-18.783 1.847-2.447-4.252z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/guarantee.6f120ccec72e3407d4ca4f6d2a554e78.svg";
export { ForwardRef as ReactComponent };